import React from 'react';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';
import Iframe from '@src/components/Iframe/Iframe';
import { IframeComponent } from '@src/interfaces';
import Countdown from '@src/components/Countdown/Countdown';

const IframeParagraph = (props: ParagraphProps) => {
  const instance = <Iframe {...(props.paragraph.data as IframeComponent)} />

  return props.paragraph.data.schedule ? <Countdown schedule={props.paragraph.data.schedule}>{instance}</Countdown> : instance;
};

export default IframeParagraph;
